import { nsSelector } from '../../../../../utils/redux';

const state = nsSelector('productionSuppliers');
export const productionSuppliers = state('list');
